import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { Shield } from 'lucide-react';

export const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user) {
      if (user.role === 'mediator') {
        navigate('/mediator/dashboard');
      } else if (['admin', 'editor'].includes(user.role)) {
        navigate('/admin/dashboard');
      }
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login({ email, password });
      if (result.success) {
        const role = result.user?.role;
        if (role === 'mediator') {
          toast.success('Vermittler-Login erfolgreich!');
          navigate('/mediator/dashboard');
        } else if (role === 'admin' || role === 'editor') {
          toast.success(role === 'admin' ? 'Admin Login erfolgreich!' : 'Editor Login erfolgreich!');
          navigate('/admin/dashboard');
        } else {
          toast.error('Keine Berechtigung für den Verwaltungsbereich');
        }
      } else {
        toast.error(result.error || 'Login fehlgeschlagen');
      }
    } catch (error) {
      toast.error('Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-[#1a1a1a] to-black flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-[#1a1a1a] border-[#C4A55A]/30">
        <CardHeader className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#C4A55A]/20 flex items-center justify-center">
            <Shield className="h-8 w-8 text-[#C4A55A]" />
          </div>
          <CardTitle className="text-3xl text-white">Admin Login</CardTitle>
          <CardDescription className="text-gray-400">
            Löwenherz Invest AG - Verwaltungsbereich
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-gray-300">E-Mail</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-[#0a0a0a] border-[#C4A55A]/30 text-white focus:border-[#C4A55A]"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-gray-300">Passwort</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#0a0a0a] border-[#C4A55A]/30 text-white focus:border-[#C4A55A]"
                required
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#C4A55A] to-[#B8974E] hover:from-[#D4B56A] hover:to-[#C4A55A] text-black font-semibold transition-all duration-300 disabled:opacity-50"
            >
              {loading ? 'Wird angemeldet...' : 'Anmelden'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};